var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0008 10.46H17.2908C16.8336 10.449 16.3834 10.3453 15.9675 10.1553C15.5515 9.96519 15.1785 9.6927 14.8709 9.35427C14.5633 9.01584 14.3276 8.61852 14.178 8.18635C14.0285 7.75418 13.9682 7.29615 14.0008 6.84V2L22.0008 10.46Z",
    fill: "url(#paint0_linear_406_14062)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M22.0007 12H17.2907C16.6379 11.9796 15.9957 11.8291 15.4018 11.5575C14.8078 11.2858 14.2741 10.8983 13.8317 10.4178C13.3894 9.93729 13.0473 9.37335 12.8257 8.759C12.604 8.14466 12.5071 7.49226 12.5407 6.84V2H7.66065C6.91735 2.01043 6.18338 2.16718 5.50066 2.46131C4.81795 2.75543 4.19986 3.18116 3.68169 3.71418C3.16353 4.2472 2.75543 4.87708 2.48073 5.56784C2.20602 6.25859 2.07007 6.9967 2.08065 7.74V16.34C2.07007 17.0833 2.20602 17.8214 2.48073 18.5122C2.75543 19.2029 3.16353 19.8328 3.68169 20.3658C4.19986 20.8988 4.81795 21.3246 5.50066 21.6187C6.18338 21.9128 6.91735 22.0696 7.66065 22.08H16.4207C17.164 22.0696 17.8979 21.9128 18.5806 21.6187C19.2634 21.3246 19.8814 20.8988 20.3996 20.3658C20.9178 19.8328 21.3259 19.2029 21.6006 18.5122C21.8753 17.8214 22.0112 17.0833 22.0007 16.34V12Z",
    fill: "url(#paint1_linear_406_14062)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_406_14062",
    x1: 13.9922,
    y1: 6.23,
    x2: 22.0008,
    y2: 6.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65CA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_406_14062",
    x1: 2.08008,
    y1: 12.04,
    x2: 22.0012,
    y2: 12.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65CA7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiles);
export default __webpack_public_path__ + "static/media/files.de0041b8869c9b53e6c291387a4318ca.svg";
export { ForwardRef as ReactComponent };